import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { ConversionCta, Footer } from "./components/Footer";
import { MobileStickyBar } from "./components/MobileStickyBar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import Accessibility from "./pages/Accessibility";
import { initAnalytics } from "./lib/api";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    initAnalytics();
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-ink pb-[57px] md:pb-0">
        <Header />
        <div className="flex-1" id="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <ConversionCta />
        <Footer />
        <MobileStickyBar />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
